<ion-header *ngIf="cards">
  <app-callcard-list-header></app-callcard-list-header>
  <app-callcard-list-filter [callcards]="cards"></app-callcard-list-filter>
  <ion-item-divider *ngIf="myCard" [class]="cardGroups.myCardCss">
    <ion-label>
      <strong>{{ 'Mobile.MyCardTitle' | translate }}</strong>
    </ion-label>
  </ion-item-divider>
  <app-callcard-list-item
    *ngIf="myCard"
    [callcard]="myCard"
    (click)="open(myCard)"
    isMyCallcard="true"
    lines="none"
    [cssClass]="cardGroups.myCardCss"
    [showStatusColor]="showStatusColor"
  ></app-callcard-list-item>
</ion-header>

<ion-content *ngIf="cards">
  <ion-list>
    <ng-container *ngFor="let cardGroup of cardGroups.cardGroups">
      <ng-container *ngIf="cardGroup.cards.length > 0 || !cardGroup.hideIfEmpty">
        <ion-item-divider sticky [class]="cardGroup.cssClass">
          <ion-label>
            <strong>{{ cardGroup.name | translate }}</strong>
          </ion-label>
          <ion-badge *ngIf="cardGroups.showCallCardCount" slot="end">{{ cardGroup.cards.length }}</ion-badge>
        </ion-item-divider>
        <ng-container *ngFor="let callcard of cardGroup.cards">
          <app-callcard-list-item
            [callcard]="callcard"
            (click)="open(callcard)"
            [cssClass]="cardGroup.cssClass"
            [showStatusColor]="showStatusColor"
          ></app-callcard-list-item>
        </ng-container>
      </ng-container>
    </ng-container>
  </ion-list>
</ion-content>

<div class="cache-loader" *ngIf="!cards">
  <ion-spinner></ion-spinner>
  <div class="cache-loader-label">{{ 'SagaMobile.Cache.Loading' | translate }}</div>
</div>
